<template>
    <div class="voiceCourseModule white_bg roundBorder4" style="box-shadow:0px 0px 8px 0px rgba(238,238,238,1);">
        <div class="inner generalPagePaddingH">
            <div class="header clearfix paddingV16">
                <div class="titleArea floatL">
                    <div class="title bold" style="font-size: 125%">{{title}}</div>
                    <div class="desc color999">{{desc}}</div>
                </div>
                <div class="opeartionArea fr">
<!--                    <router-link class="color999 font12r" to="/">更多 <span class="angleBracketsFont">&gt;</span></router-link>-->
                </div>
            </div><!-- end header -->
            <div class="body hiddenScrollbar paddingB20" style="overflow: auto">
                <div class="list clearfix hiddenScrollbar" :class="layout"
                     :style="layout === 'horizontalCardLayout' ? 'width: ' + (120 + 18) * dataList.length + 'px' : ''">
                    <div class="item" v-for="dataItem in dataList.slice(0, 3)"
                         :key="dataItem.id" @click="viewItem(dataItem)">

                        <!-- 水平卡片布局 -->
                        <div class="inner" v-if="layout === 'horizontalCardLayout'">
                            <div class="imageArea marginB8">
                                <img class="cover fullSpace roundBorder4" :src="dataItem.coverImg"
                                     style="width: 120px; height: 116px;"/>
                            </div>
                            <div class="titleArea font16r color333 bold">{{dataItem.title}}</div>
                        </div>

                        <!-- 水平3卡片布局 -->
                        <div class="inner" v-if="layout === 'horizontal3CardLayout'">
                            <div class="imageArea marginB8">
                                <img class="cover fullSpace" :src="dataItem.coverImg"/>
                                <div class="descArea f12 white">
                                    共{{dataItem.applicantCount}}人学
                                </div>
                            </div>
                            <div class="titleArea font16r color333 bold">{{dataItem.title}}</div>
                        </div>

                        <!-- 纵向图文布局 -->
                        <div class="inner flexLayout" v-if="layout === 'verticalImageTextLayout'">
                            <div class="imageArea" style="width: 120px;">
                                <img class="cover fullSpace roundBorder8" :src="dataItem.coverImg"/>
                            </div>
                            <div class="flexItem paddingL8">
                                <div class="titleArea f18 color333 bold">
                                    {{dataItem.title}}
                                </div>
                                <div class="priceArea">
                                    组合价：
                                    <strong class="red">￥{{dataItem.price}}</strong>

                                    <span class="color999" style="font-size: 12px; margin-left: 8px;">
                                        立省{{dataItem.marketPrice - dataItem.price}}元
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- 表格两栏卡片布局 -->
                        <div class="inner" v-if="layout === 'table2ColumnCardLayout'">
                            <div class="imageArea marginB8">
                                <img class="cover fullSpace roundBorder8" :src="dataItem.coverImg"/>
                            </div>
                            <div class="titleArea f15 color333 bold marginB8 textOverflowShowEllipsis">
                                {{dataItem.title}}
                            </div>
                            <div class="priceArea" style="font-size: 10px">
                                组合价：
                                <strong class="red f16r10">￥{{dataItem.price || 0}}</strong>

                                <span class="color999" style="margin-left: 8px;">
                                    立省{{dataItem.discount || 0}}元
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import generalCmpPart from '@comp/part/generalCmpPart';

// style
import '@comp/voiceCourse/voiceCourse.scss';

// utils
import consoleHelper from '@util/consoleHelper';
import numberHelper from '@util/numberHelper';
import appHelper from '@util/appHelper';

// config
const config = {
    apiConfig : {
        list : {
            url : 'portal/api/audio/latest',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            params : {
                limit : 3,
                chargeMode : 'FREE'
            },
            dataColumnMapping : {
                sectionCount : 'liveCount'
            }
        }
    }
};

export default {
    name: "voiceCourseModule",
    extends : generalCmpPart,
    props : {
        title : {
            type : String,
            default : ''
        },
        desc : {
            type : String,
            default : ''
        },
        layout : {
            type : String,
            default : 'horizontal3CardLayout'
        },
        itemCount : {
            type : Number,
            default : 3
        },
        dataParams : {
            type : Object,
            default : () => {
                return {}
            }
        },
    },
    data () {
        return {
            apiConfig : config.apiConfig
        }
    },
    methods : {
        generateDemoData : function () {
            let list = [];
            for (let i=0; i<3; i++)
            {
                var tItem = {
                    id : i,
                    title : '园长“苦恼”，幼儿园之间到底在竞争什么',
                    coverImg : appHelper.getRandomCoverImage(),
                    sectionCount : 260,
                    duration : numberHelper.getRandomInteger(2 * 60 * 60),
                    chargeMode : numberHelper.getRandomInteger(2) > 1
                };
                tItem.durationText = moment(tItem.duration * 1000).format('HH小时mm分钟');
                list.push(tItem);
            }

            this.dataList = list;
        },
        viewItem : function (dataItem) {
            appHelper.redirect('/voiceCourse/detail/' + dataItem.id);
        }
    },
    mounted() {
        this.pageSize = this.pagination.pageSize = this.itemCount;
        this.apiConfig.list.params = this.dataParams;
        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>

</style>
